{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-biologie-pflanzen-fotosynthese",
  "version": "2026.08.1",
  "title": "Biologie 7: Pflanzenorgane, Blattaufbau und Fotosynthese (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Biologie 7: Organe der Samenpflanze, mikroskopischer Laubblattbau, Stomata-Regulation, Fotosynthese vs. Zellatmung und Wassertransport.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:45:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/biologie",
      "checked": "2026-08-15",
      "label": "Realschule Biologie 7, Lernbereich Pflanzen und Fotosynthese"
    }
  ],
  "atoms": [
    {
      "id": "01K4B7F0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4B7F0000000000000000A01",
      "namespace": "biologie-botanik",
      "slug": "organe-der-samenpflanze-wurzel-spross-blatt",
      "title": "Organe der Samenpflanze: Wurzel, Sprossachse, Laubblatt und Leitgewebe",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Plant physiology",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B7F0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welches pflanzliche Leitgewebe transportiert Wasser und gelöste Mineralsalze von der Wurzel aufwärts in die Blätter?",
          "concept": "Das Xylem (Holzteil des Leitbündels mit abgestorbenen Röhrenzellen / Tracheen)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Das Xylem (Holzteil / Aufwärtstransport)",
              "Das Phloem (Bastteil / Assimilatetransport)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B7F0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Beschreibe den Bau und die Hauptfunktionen der drei vegetativen Grundorgane einer Samenpflanze (Wurzel mit Wurzelhaaren, Sprossachse mit Leitbündeln, Laubblatt) und unterscheide den Wassertransport im Xylem (Transpirationssog, Kapillarkräfte, Wurzeldruck) vom Nährstofftransport im Phloem (Siebröhren).",
          "concept": "Wurzel: Verankerung, Wasser-/Nährsalzaufnahme über Wurzelhaare, Speicherorgan; Sprossachse: Stabilität, Blattausrichtung, Leitungssystem; Laubblatt: Fotosynthese & Transpiration; Xylem (Holzteil): zieht Wasser nach oben durch Transpirationssog; Phloem (Bastteil): transportiert Zuckerlösung (Assimilate) zu Speicherorten (Wurzeln, Früchten).",
          "sample_solution": "1. Die drei vegetativen Grundorgane der Samenpflanze: - Wurzel:   * Verankerung der Pflanze fest im Erdreich.   * Aufnahme von Wasser und gelösten Mineralsalzen (Nitrate, Phosphate, Kalium) aus dem Bodenwasser über eine riesige Oberfläche aus feinsten, einzelligen Wurzelhaaren (Prinzip der Oberflächenvergrößerung).   * Speicherung von Reservestoffen (z. B. Speicherwurzeln wie Rüben, Knollen). - Sprossachse (Stängel / Stamm):   * Trägt und positioniert Blätter und Blüten optimal zum Sonnenlicht.   * Enthält Leitbündel zur Fernleitung von Stoffen zwischen Wurzel und Krone. - Laubblatt:   * Hauptorgan der Fotosynthese (Kohlenhydratsynthese) und der Transpiration (regulierbare Wasserverdunstung). 2. Die Leitgewebe im Vergleich: - Xylem (Holzteil): Besteht aus abgestorbenen, verholzten Röhren (Tracheen und Tracheiden). Transportiert Wasser und anorganische Nährsalze unidirektional von den Wurzeln nach oben in die Blätter. Der Antrieb erfolgt primär durch den **Transpirationssog** der verdunstenden Blätter (Unterdruck), unterstützt durch Kapillarkräfte und osmotischen Wurzeldruck. - Phloem (Bastteil): Besteht aus lebenden Siebröhren und Geleitzellen. Transportiert die bei der Fotosynthese gebildeten organischen Nährstoffe (Assimilate, vor allem Saccharose-Zuckerlösung) bidirektional von den Blättern ('Source') zu den wachsenden Organen, Blüten, Früchten oder Speicherwurzeln ('Sink')."
        }
      ]
    },
    {
      "id": "01K4B7F0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4B7F0000000000000000A02",
      "namespace": "biologie-botanik",
      "slug": "laubblatt-querschnitt-gewebeschichten-stomata",
      "title": "Mikroskopischer Bau des Laubblatts: Cuticula, Palisadengewebe, Schwammgewebe und Spaltöffnungen",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4B7F0000000000000000A01",
          "type": "hard",
          "rationale": "Das Laubblatt ist das anatomische Organ für die mikroskopischen Gewebeschichten."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Leaf anatomy",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B7F0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "In welcher Gewebeschicht des Laubblatts befinden sich die meisten Chloroplasten für eine maximale Fotosyntheserate?",
          "concept": "Im Palisadengewebe (Palisadenparenchym unter der oberen Epidermis)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Im Palisadengewebe (Palisadenparenchym)",
              "In der oberen Epidermis"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B7F0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Zeichne und beschreibe den schichtweisen Querschnitt eines bifazialen Laubblatts (Cuticula, obere Epidermis, Palisadengewebe, Leitbündel, Schwammgewebe mit Interzellularen, untere Epidermis, Spaltöffnungen / Stomata mit Schließzellen) und erkläre den Öffnungs- und Schließmechanismus der Spaltöffnungen durch Turgordruckveränderungen (Schutz vor Vertrocknung vs. CO_2-Aufnahme).",
          "concept": "Schichten von oben nach unten: 1. Wachsartige Cuticula (Verdunstungsschutz), 2. Obere Epidermis (chloroplastenfrei, lichtdurchlässig), 3. Palisadengewebe (dicht gepackte zylindrische Zellen mit 80% aller Chloroplasten -> Hauptort Fotosynthese), 4. Schwammgewebe (locker mit großen luftgefüllten Zwischenräumen für Gasaustausch), 5. Untere Epidermis mit Stomata; Spaltöffnungen: 2 bohnenförmige Schließzellen mit ungleich dicken Wänden; hoher Turgor (Wasserfülle) -> krümmen sich, Spalt öffnet sich (CO2 strömt ein); Wassermangel -> Turgor sinkt, Spalt schließt (Verdunstungsschutz).",
          "sample_solution": "1. Schichten eines Laubblatts im Querschnitt (von oben nach unten): - Cuticula: Wachsartige, wasserundurchlässige Schicht auf der Außenwand der Epidermis; schützt vor unkontrollierter Verdunstung und mechanischen Beschädigungen. - Obere Epidermis: Einschichtiges, lückenloses Abschlussgewebe; enthält (außer bei Wasserpflanzen) keine Chloroplasten, um das Sonnenlicht ungehindert in tiefere Schichten durchzulassen. - Palisadengewebe (Palisadenparenchym): Dicht aneinandergereihte, säulenförmige Zellen; enthält ca. 80 % aller Chloroplasten des Blattes; ist der Hauptort der Fotosynthese. - Schwammgewebe (Schwammparenchym): Unregelmäßig geformte Zellen mit weiten, luftgefüllten Zellzwischenräumen (Interzellularen); dient primär dem Gasaustausch (CO_2- und O_2-Diffusion) und der Wasserdampfabgabe; durchzogen von Blattadern (Leitbündeln). - Untere Epidermis mit Spaltöffnungsapparaten (Stomata): Enthält mikroskopische Poren zur regulierten Transpiration und zum Gasaustausch. 2. Regulationsmechanismus der Spaltöffnungen (Stomata): - Jede Spaltöffnung besteht aus zwei chloroplastenhaltigen, bohnenförmigen Schließzellen, deren dem Spalt zugewandte Zellwände verdickt und unelastisch sind. - Hohe Wasserversorgung / Licht (hoher Turgordruck): Kaliumionen strömen osmotisch in die Schließzellen; Wasser strömt nach; der Innendruck (Turgor) steigt. Die dünneren Außenwände dehnen sich stärker als die starren Innenwände -> die Zellen wölben sich auseinander, der Spalt öffnet sich (CO_2 kann für die Fotosynthese einströmen). - Wassermangel / Dunkelheit (sinkender Turgor): Kalium und Wasser verlassen die Schließzellen; der Turgordruck sinkt -> die Zellen erschlaffen und legen sich aneinander, der Spalt schließt sich luftdicht (Verhinderung des Vertrocknens der Pflanze)."
        }
      ]
    },
    {
      "id": "01K4B7F0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4B7F0000000000000000A03",
      "namespace": "biologie-botanik",
      "slug": "fotosynthese-wortgleichung-chemische-reaktion",
      "title": "Die Fotosynthese: Edukte, Produkte, Chlorophyll und die photochemische Gesamtgleichung",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4B7F0000000000000000A02",
          "type": "hard",
          "rationale": "Palisadengewebe und Chloroplasten sind die zellulären Orte der Fotosynthese."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Photosynthesis",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B7F0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche beiden Stoffe stellen die Ausgangsstoffe (Edukte) für die Fotosynthese der grünen Pflanzen dar?",
          "concept": "Wasser (H_2O) und Kohlenstoffdioxid (CO_2)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Wasser und Kohlenstoffdioxid",
              "Glukose und Sauerstoff"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B7F0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Formuliere die Wortgleichung und die chemische Summengleichung der Fotosynthese (6 CO_2 + 6 H_2O -> C_6H_12O_6 + 6 O_2), erläutere die Rolle des grünen Blattfarbstoffs Chlorophyll als Lichtantenne (Absorption von rotem und blauem Licht, Reflexion von Grün) und beschreibe den klassischen Stärkenachweis an einem panaschierten (weiß-grün gemusterten) Efeublatt nach Belichtung.",
          "concept": "Wortgleichung: Kohlenstoffdioxid + Wasser + Lichtenergie -> Glukose + Sauerstoff; Summengleichung: 6 CO2 + 6 H2O -> C6H12O6 + 6 O2; Chlorophyll absorbiert blaues und rotes Licht, nutzt Energie für Wasserspaltung, reflektiert grünes Licht; Panaschiertes Blatt: nur die grünen Blattzonen mit Chlorophyll färben sich mit Lugolscher Lösung blauschwarz (Stärke nachgewiesen), weiße zellfreie Zonen bleiben braun/gelb (keine Fotosynthese ohne Chlorophyll).",
          "sample_solution": "1. Reaktionsgleichungen der Fotosynthese: - Wortgleichung: Kohlenstoffdioxid + Wasser + Lichtenergie (Sonnenlicht) --[Chloroplasten/Chlorophyll]--> Traubenzucker (Glukose) + Sauerstoff. - Chemische Summengleichung: 6 CO_2 + 6 H_2O --[Licht/Chlorophyll]--> C_6H_12O_6 + 6 O_2. 2. Die Rolle des Chlorophylls: - Chlorophyll (Blattgrün) ist ein Farbpigment in den Thylakoidmembranen der Chloroplasten. - Es absorbiert vor allem energiereiches blaues und rotes Licht des Sonnenspektrums und wandelt die Lichtenergie in chemische Energie (ATP und Reduktionsäquivalente) um. - Grünes Licht wird nicht absorbiert, sondern reflektiert ('Grünlücke'), weshalb Pflanzen für das menschliche Auge grün erscheinen. 3. Stärkenachweis am panaschierten Efeublatt (Versuch nach Sachs): - Durchführung: Ein panaschiertes (grün-weiß gerandetes) Blatt wird mehrere Stunden intensiv belichtet. Anschließend wird das Blatt in heißem Wasser abgetötet, in siedendem Ethanol entfärbt (Chlorophyll herausgelöst) und mit Lugolscher Lösung (Iod-Kaliumiodid) beträufelt. - Beobachtung & Auswertung: Nur die ehemals **grünen Blattbereiche** färben sich intensiv tiefblau-schwarz (Nachweis von gespeicherter Stärke, die aus Glukose polymerisiert wurde). Die ehemals **weißen Zonen** (ohne Chlorophyll) bleiben gelblich-braun. Dies beweist experimentell, dass Fotosynthese zwingend an das Vorhandensein von Chlorophyll gebunden ist."
        }
      ]
    },
    {
      "id": "01K4B7F0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4B7F0000000000000000A04",
      "namespace": "biologie-botanik",
      "slug": "fotosynthese-vs-zellatmung-kompensationspunkt",
      "title": "Fotosynthese versus Zellatmung bei Pflanzen: Energiebilanz und Lichtkompensationspunkt",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4B7F0000000000000000A03",
          "type": "hard",
          "rationale": "Fotosynthese bildet das Gegenstück zur pflanzlichen Zellatmung."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Cellular respiration",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "biologie",
          "topic_code": "lb3",
          "topic_title": "Pflanzen und Fotosynthese",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B7F0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welcher Gaswechsel findet bei einer grünen Pflanze in der Nacht bei völliger Dunkelheit statt?",
          "concept": "Ausschließlich Zellatmung: Aufnahme von O_2 und Abgabe von CO_2",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Aufnahme von O_2 und Abgabe von CO_2 (Zellatmung)",
              "Aufnahme von CO_2 und Abgabe von O_2 (Fotosynthese)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B7F0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Stelle Fotosynthese und Zellatmung in Pflanzen in einer vergleichenden Übersicht gegenüber (Ort in der Zelle, Zeit/Bedingungen, Energieumwandlung, Edukte, Produkte) und erkläre den Begriff des 'Lichtkompensationspunkts' (wo Sauerstoffproduktion der Fotosynthese exakt gleich dem Sauerstoffverbrauch der Zellatmung ist).",
          "concept": "Fotosynthese: Chloroplasten, nur bei Licht, Lichtenergie -> chemische Energie (Glukose), Edukte CO2 + H2O, Produkte Glukose + O2; Zellatmung: Mitochondrien, Tag & Nacht (rund um die Uhr), Abbau von Glukose zur Energiegewinnung (ATP), Edukte Glukose + O2, Produkte CO2 + H2O; Lichtkompensationspunkt: Lichtstärke, bei der CO2-Fixierung = CO2-Freisetzung (Nettofotosynthese = 0).",
          "sample_solution": "1. Gegenüberstellung von Fotosynthese und Zellatmung bei Pflanzen: - Reaktionsort:   * Fotosynthese: Chloroplasten (Thylakoide und Stroma).   * Zellatmung: Mitochondrien und Cytoplasma. - Zeit & Voraussetzungen:   * Fotosynthese: Nur tagsüber bei ausreichender Lichtintensität (lichtabhängig).   * Zellatmung: Rund um die Uhr (Tag und Nacht, kontinuierlich). - Energetik & Energiefluss:   * Fotosynthese: Endotherm (Aufbau energiereicher Verbindungen; Umwandlung von Strahlungsenergie in chemisch gebundene Energie in Glukose).   * Zellatmung: Exotherm (Betriebsstoffwechsel; schrittweiser oxidativer Abbau von Glukose zur universellen Energiegewinnung in Form von ATP für Wachstum, Transport und Biosynthesen). - Stoffbilanz:   * Fotosynthese: 6 CO_2 + 6 H_2O -> C_6H_12O_6 + 6 O_2.   * Zellatmung: C_6H_12O_6 + 6 O_2 -> 6 CO_2 + 6 H_2O. 2. Der Lichtkompensationspunkt: - Definition: Diejenige spezifische Beleuchtungsstärke (Lichtintensität), bei der die Sauerstoffbildungsrate der Fotosynthese exakt gleich groß ist wie die Sauerstoffverbrauchsrate der Zellatmung der Pflanze. - Bei dieser Lichtstärke ist der Netto-Gaswechsel der Pflanze null (CO_2-Aufnahme = CO_2-Abgabe; Nettofotosynthese = 0). - Erst oberhalb des Lichtkompensationspunkts erzielt die Pflanze einen echten Biomassegewinn (Überschuss an Glukose und Sauerstofffreisetzung in die Atmosphäre)."
        }
      ]
    }
  ]
}
